export default {
  title: 'Επικοινωνία για Υποστήριξη',
  form: {
    firstName: 'Όνομα',
    lastName: 'Επίθετο',
    nickname: 'Επωνυμία',
    phoneNumber: 'Τηλέφωνο',
    email: 'E-Mail',
    emailVerification: 'Επαλήθευση E-Mail',
    subject: {
      label: 'θέμα',
      options: ['Λάθος', 'Χρέωση', 'Σύνδεση', 'Ανατροφοδότηση', 'Βελτίωση'],
    },
    message: 'Nachricht',
    button: 'Στείλετε',
  },
  errors: {
    requiredField: 'Αυτό το πεδίο είναι υποχρεωτικό.',
    sendFailed: 'Κάτι πήγε στραβά. Δοκιμάστε ξανά αργότερα',
  },
  success: {
    title: 'Κατάλαβα!',
    message:
      'Ένας από τους αντιπροσώπους υποστήριξης θα επικοινωνήσει μαζί σας το συντομότερο δυνατό.',
  },
};
